import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { MemoryRouter } from 'react-router-dom';

import './fonts/fonts.css';
import App from './pages/App';
import GlobalStyle from './styles';
import { DataProvider, SleepModeProvider, SliderProvider } from './context';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <MemoryRouter basename="/">
    <SleepModeProvider>
      <GlobalStyle />
      <DataProvider>
        <SliderProvider>
          <App />
        </SliderProvider>
      </DataProvider>
    </SleepModeProvider>
  </MemoryRouter>,
);
